// static data for the chatbot
export const DEFAULT_PROMPT = [
  { id: 1, value: 'What is the current hunger situation in Africa?' },
  { id: 2, value: 'How does climate change affect food security?' },
  { id: 3, value: "What are WFP's main initiatives to combat hunger?" },
];

export const WELCOME_MESSAGE = 'Welcome to HungerMap ChatBot!';

export const SUB_WELCOME_MESSAGE = 'How can I assist you today?';

export const NEW_CHAT_BUTTON = 'New Chat';

export const CHAT_TITLE = 'HungerMap ChatBot';

export const TYPING_PLACEHOLDER = 'Type a message...';

export const ENTER_FULL_SCREEN = 'Enter full screen';

export const EXIT_FULL_SCREEN = 'Exit Full Screen';

export const OPEN_SIDE_BAR = 'Open chat side bar';

export const CLOSE_SIDE_BAR = 'Close chat side bar';

export const TRIGGER_CHAT = 'Chatbot';
